import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from 'screens/components/basic/Button';
import * as XLSX from 'xlsx';
import { importEmployeeTemplate } from '../../../actions/EntityActions.js';
import ConfirmDialog from './ConfirmEmployeeTemplateDialog.js';

class ExcelUploadEmployee extends Component {
    constructor(props) {
        super(props);

        this.state = {
            confirmDialog: false,
            totalPriceMatch: false,
            POName: '',
            model: {}
        };
    }

    callback = (model) => {
         this.setState({ model: model, confirmDialog: true });   
    }
    uploadFile = (e, callback) => {
        e.preventDefault();
        let BranchId = this.props.branchId;
       
        let reader = new FileReader();
        reader.readAsArrayBuffer(e.target.files[0]);
        reader.onload = function (e) {
            let data = new Uint8Array(reader.result);
            let wb = XLSX.read(data, { type: 'array' });

            let sheetName = wb.SheetNames[0];
            let worksheet = wb.Sheets[sheetName];
            let json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            let EmployeeArray = [];
            for (let i = 1; i < json.length; i++) {
                let data = json[i];
                let FirstName = data[0];
                let LastName = data[1];
                let Email=data[2];
                let Role=data[3];
                let UserName=data[2];
                let model = {
                    FirstName,
                    LastName,
                    Email,
                    UserName,
                    Role
                };

                EmployeeArray.push(model);
            }

            let model = {
                BranchId,
                Employees: EmployeeArray
            }

            callback(model);
        }
    }

    closeDialog = () => {
        this.setState({ confirmDialog: false });
        this.setState({ totalPriceMatch: false, POName: "", model: {} });
    }

    createPO = () => {
       
        this.props.importEmployeeTemplate(this.state.model);
        this.closeDialog();
    }

    render() {
        const styles = {
            uploadInput: {
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: '2px',
                left: 0,
                width: '40%',
                opacity: 0
            }
        };
        return (
            <Button
                    label="Import FROM Employees TEMPLATE"
                    style={styles.uploadButton}
                    className="bg-light-green"
                    mini={true}
                >
                    <input className="fileInput"
                        type="file"
                        style={styles.uploadInput}
                        onChange={(e) => this.uploadFile(e, this.callback)}
                        onClick={(e) => e.target.value = null} />

                    <ConfirmDialog
                        branchName={this.props.branchName}
                         model={this.state.model}
                        confirmDialog={this.state.confirmDialog}
                        closeDialog={this.closeDialog}
                        createPO={this.createPO} />
                </Button>

        );
    }
}

function mapStatetoProps(state) {
    return {
        branchId: state.common.branchId,
        province: state.common.store.provinceState,
        branchName: state.common.store.name || '',
        purchaseOrderList: state.entity.purchaseOrderList || []
    };
}

function mapDispatchToProps(dispatch) {
    return { 
        importEmployeeTemplate: (model) => dispatch(importEmployeeTemplate(model))
    }
}

export default connect(mapStatetoProps, mapDispatchToProps)(ExcelUploadEmployee);